import { PopularDestinations } from 'shared/seo/PopularDestinations';
import flight from '@/components/internalLinks/flight.json';
import hotel from '@/components/internalLinks/hotel.json';
import { InternalLinksSection } from '@/components/internalLinks/InternalLinksSection';
import prepackage from '@/components/internalLinks/prepackage.json';
import { transformDestinations, transformFlightDestinations } from '@/components/internalLinks/transformDestinations';
import data from './data/flight.json';
import { toDestinations } from './toDestinations';

export const FlightSeo = () => {
    const flightItems = transformFlightDestinations(flight);
    const prepackageItems = transformDestinations(prepackage, 'pakkereiser');
    const hotelItems = transformDestinations(hotel, 'hotell');

    const cities = toDestinations(data.cities, data.cdnPath, data.basePath, data.altPrefix);
    const countries = toDestinations(data.countries, data.cdnPath, data.basePath, data.altPrefix);

    return (
        <>
            <PopularDestinations id="seo-flight-cities" heading={data.citiesHeading} destinations={cities} />
            <InternalLinksSection title="Finn flyreiser til populære byer" titleId="seo-flights-to-popular-cities" items={flightItems} />
            <PopularDestinations id="seo-flight-countries" heading={data.countriesHeading} destinations={countries} />
            <InternalLinksSection
                title="Finn pakkereiser til spennende steder"
                titleId="seo-pp-to-exciting-places"
                items={prepackageItems}
            />
            <InternalLinksSection title="Finn rimelige hoteller i Europa" titleId="seo-cheap-hotels-in-europe" items={hotelItems} />
        </>
    );
};
